module.exports = __webpack_public_path__ + "img/count.f0893a90.gif";